import React, { useState } from 'react';
import './Login.css';
import Waves from '../Components/Extras/Waves';
import LoginForm from '../Components/Layout/LoginForm';

import Lock from '../Assets/Videos/Lock0001-0100.webm'
import LoginBg from '../Assets/decals/LoginBg.svg'

const Login = () => {

    const [formState, setFormState] = useState(false);

    return ( 
        <main className='Login'>
            <Waves />

            <img className={formState ? 'LoginBg LoginBgAnim' : 'LoginBg'} src={LoginBg} alt="" />
            
            <section className='LoginContent'>
                <div className='LoginHeader'>
                    <div className='IconAnim'>
                        <video className='LoginIcon' muted autoPlay src={Lock}></video>
                    </div>

                    <p className='LoginTitle'>
                        Log in
                    </p>
                    <p className='LoginSub'>
                    Sign back in or create an acoount in seconds
                    </p>
                </div>

                <LoginForm setAuth={setFormState}/>
                
            </section>
        </main>
     );
}
 
export default Login;